import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UtilityService {
  public userEmail: string;
  public transactionsCurrentTab: string;
  private mediaUrl = environment.MEDIA_SERVICE;

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  clearStorage() {
    return localStorage.clear();
  }

  showLoading() {
    this.spinner.show();
  }

  hideLoading() {
    this.spinner.hide();
  }

  showSuccessToast(msg) {
    this.toastr.success(msg);
  }

  showErrorToast(msg) {
    this.toastr.error(msg);
  }

  showInfoToast(msg) {
    this.toastr.info(msg);
  }
  getTimezoneName() {
    const full = new Date().toLocaleDateString(undefined, {
      timeZoneName: "short",
    });
    return full.split(",")[1].trim();
  }
  base64ToFile(data, filename) {
    const arr = data.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    let date = new Date();
    filename = date.getTime() + filename;
    return new File([u8arr], filename, { type: mime });
  }
  downloadFromUrl(fileUrl) {
    let url = this.mediaUrl + fileUrl;
    const link = document.createElement("a");
    link.href = url;
    document.body.appendChild(link);
    link.click();
  }
}
